function setupAndBindDecisionsEvents(campaignId, decisionId) {
  var decisionClick = false;

  function refreshDecisions() {
    $('#spinner').show();
    $.get('/campaigns/' + campaignId + '/threeway/decisions', {q: $('#q').val()}, function (data) {
      $('#spinner').hide();
      $('#decisions').html(data);
      if (decisionId && !decisionClick) {
        $('#decision-' + decisionId + ' a').click();
        decisionClick = true;
      }
    });
  }

  $(function () {
    $("#q").keyup(function () {
      if ($(this).val().length == 0)
        refreshDecisions();
    });
    $("#q").typeWatch({
      callback: refreshDecisions,
      wait: 250
    });
    refreshDecisions();
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupAndBindDecisionsEvents;